"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concatenate = void 0;
const concatenate = ({ leftValue, rightValue, }) => {
    const result = `${leftValue}${rightValue}`;
    return { error: null, result };
};
exports.concatenate = concatenate;
//# sourceMappingURL=concatenate.js.map